// Optional dining thumbnails. Two sources, in priority order (see
// DiningTonight.jsx): a hand-placed licensed local file registered in
// DINING_PHOTOS, then the restaurant's Google Place photo (stamped onto each
// pick as photoRef by the brief synthesis and served through the
// /api/dining-photo proxy). A pick with neither shows a monogram tile — never a
// broken image — so partial coverage still looks deliberate.
//
// The local map is now an OVERRIDE: use it only when you have a better, licensed
// photo than Google's, or to pin a specific image. Photos are keyed off a
// normalized name slug rather than a bench id, because the brief's picks carry a
// name, not an id. Only add files you have the right to use.

// "The Obstinate Daughter" -> "obstinate-daughter"; "167 Raw" -> "167-raw";
// "Red's Ice House" -> "reds-ice-house". Drops a leading "The ", folds "&" to
// "and", and collapses anything non-alphanumeric to single hyphens.
export function diningSlug(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/^the\s+/, '')
    .replace(/&/g, ' and ')
    .replace(/[''’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// slug -> public path. Empty by default; fill in as real photos are added.
// e.g. 'obstinate-daughter': '/dining/obstinate-daughter.jpg'
export const DINING_PHOTOS = {};

export function diningPhoto(name) {
  return DINING_PHOTOS[diningSlug(name)] || null;
}

// The proxy URL for a pick's Google Place photo. Width is the rendered tile at
// 2x (72px → 144). Returns null when the pick has no Google reference.
export function googleDiningPhoto(photoRef, width = 144) {
  if (!photoRef) return null;
  return `/api/dining-photo?ref=${encodeURIComponent(photoRef)}&w=${width}`;
}

// Google returns photo attribution as an HTML anchor string (e.g.
// '<a href="...">A Contributor</a>'). Rendering that requires injecting HTML, so
// instead we extract a safe {text, href} and build a real React link. Google's
// terms require these attributions to be shown wherever a Place photo appears.
export function parseAttribution(html) {
  if (!html) return null;
  const href = (String(html).match(/href="([^"]+)"/i) || [])[1] || null;
  const text = String(html).replace(/<[^>]*>/g, '').trim();
  if (!text) return null;
  return { text, href };
}
